// src/components/SessionInputPanel.tsx
"use client";

import { useRecordContext } from "@/contexts/RecordContext";
import type { DraftEntry } from "@/types/Entry";

const MAX_CHARS = 200;

type SessionInputPanelProps = {
  className?: string;
};

export default function SessionInputPanel({ className = "" }: SessionInputPanelProps) {
  const recordContext = useRecordContext();

  if (
    !recordContext ||
    recordContext.userProfileLoading ||
    !recordContext.userProfile
  ) {
    return <div style={{ color: "red" }}>ユーザープロファイル未取得中...</div>;
  }

  const {
    draftEntries,
    setDraftEntries,
    selectedTopic,
  } = recordContext;

  const filteredDraftEntries =
    draftEntries.filter((entry) => entry.source === "card" || entry.source === undefined);

  return (
    <div id="session-input" className={`w-full ${className}`}>
      {selectedTopic && (
        <div className="text-sm text-gray-600 font-medium border-b pb-1 mb-3">
          📌 現在のお題: {selectedTopic.topic}
        </div>
      )}

      {filteredDraftEntries.length === 0 ? (
        <p className="text-sm text-gray-400">カードを選んで「書く」を押すとここに入力欄が現れます。</p>
      ) : (
        <div className="space-y-3">
          {filteredDraftEntries.map((entry) => (
            <div key={entry.id} className="text-sm">
              <div className="relative">
                <textarea
                  data-entry-id={entry.id}
                  rows={1}
                  value={entry.text}
                  maxLength={MAX_CHARS}
                  onChange={(e) => {
                    setDraftEntries((prev: DraftEntry[]) =>
                      prev.map((item) =>
                        item.id === entry.id
                          ? { ...item, text: e.target.value }
                          : item
                      )
                    );
                    // auto-grow
                    e.target.style.height = "auto";
                    e.target.style.height = e.target.scrollHeight + "px";
                  }}
                  onFocus={(e) => {
                    // 初回フォーカス時も高さ同期
                    e.target.style.height = "auto";
                    e.target.style.height = e.target.scrollHeight + "px";
                  }}
                  className="w-full px-2 py-1.5 text-base border rounded resize-none overflow-hidden"
                  style={{ minHeight: "2rem" }}
                />
                <button
                  type="button"
                  onClick={() =>
                    setDraftEntries((prev: DraftEntry[]) =>
                      prev.filter((e) => e.id !== entry.id)
                    )
                  }
                  className="absolute top-1 right-1 text-xs text-gray-300 hover:text-gray-500 px-1 leading-none"
                  title="取り消す"
                >
                  ×
                </button>
              </div>
              <div className="flex justify-end mt-0.5">
                <span className={`text-xs ${entry.text.length > MAX_CHARS * 0.9 ? entry.text.length >= MAX_CHARS ? "text-red-500 font-medium" : "text-orange-400" : "text-gray-400"}`}>
                  {entry.text.length} / {MAX_CHARS}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
